export default () => ({
  init() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    }

    const invertCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log(entry.target.getAttribute('data-bg'))
          document.body.style.setProperty('--bg', entry.target.getAttribute('data-bg') ?? '#FFFFFF')
          document.body.style.setProperty('--color', entry.target.getAttribute('data-text') ?? '#000000')
        } else {
          document.body.style.removeProperty('--bg')
          document.body.style.removeProperty('--color')
        }
      })
    }

    const revertCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.body.style.removeProperty('--bg')
          document.body.style.removeProperty('--color')
        }
      })
    }

    this.$refs.app.querySelectorAll(':scope  > .invert, .single-work--content > .invert').forEach(el => {
      const prevEl = el.previousElementSibling ?? false
      const nextEl = el.nextElementSibling ?? false

      let optionsFinal = {
        ...options
      }

      if (nextEl?.classList?.contains('global--page-cta')) {
        optionsFinal.rootMargin = '9999px 0px 0px 0px'
      }

      if (el.hasAttribute('data-threshold')) {
        optionsFinal.threshold = el.getAttribute('data-threshold')
      }

      const inverter = new IntersectionObserver(invertCallback, optionsFinal)
      const reverter = new IntersectionObserver(revertCallback, options)

      inverter.observe(el)

      if (prevEl !== false) {
        reverter.observe(prevEl)
      }

      if (nextEl !== false && ! nextEl.classList?.contains('global--page-cta')) {
        reverter.observe(nextEl)
      }
    })
  }
})